<template>
  <component
    :is="page"
    v-if="page !== null && !pageLoading"
    :contexts="contexts"
  />
  <iColumn
    v-if="pageLoading"
    width="fill"
    height="fill"
    align="center"
    vertical-align="middle"
  >
    <iText>Loading Page</iText>
    <iLoadingSpinner v-if="pageLoading" />
  </iColumn>
  <iColumn
    v-if="!pageLoading && page === null"
    width="fill"
    height="fill"
    align="center"
    vertical-align="middle"
  >
    <iText>Page Not Found or available</iText>
  </iColumn>
</template>

<script>
import App from "+/Engine/App.js";

export default {
  name: "AppPage",
  components: {
  },
  provide() {
    return {
      appName: this.appName,
      // TODO: thinking of providing current user context globally here - can then be injected and accessed everywhere
    };
  },
  props: {
    appName: {
      type: String,
      required: true,
    },
    contexts: {
      type: Object,
      required: true,
    },
    pageName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      page: null,
      pageLoading: false,
    };
  },
  computed: {
  },
  async created() {
    this.pageLoading = true;
    const app = await App.create(this.appName, 0);
    const page = app.getPage(this.pageName);
    this.page = page;
    this.pageLoading = false;
  },
};
</script>
